import React from 'react';
import _ from 'lodash';
import { Card, Checkbox, Grid } from 'semantic-ui-react';

const BlogosphereCollaborationTypes = props => {
  const {
    details: {
      complimentaryPressTrips,
      paidForPressTrips,
      sponsoredPosts,
      productSamples,
    },
  } = props;
  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>Types of collaboration</Card.Header>
      </Card.Content>
      <Card.Content>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Checkbox label="Product Samples" checked={_.isString(productSamples)} />
            </Grid.Column>
            <Grid.Column>
              <Checkbox checked={_.isString(complimentaryPressTrips)} label="Complimentary Press Trips" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Checkbox label="Sponsored Posts" checked={_.isString(sponsoredPosts)} />
            </Grid.Column>
            <Grid.Column>
              <Checkbox label="Paid For Press Trips" checked={_.isString(paidForPressTrips)} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
};


export default BlogosphereCollaborationTypes;



/** WEBPACK FOOTER **
 ** ./src/components/blogosphere-collaborations-types/index.js
 **/